import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { MainProvider } from 'providers';
import { FlashModal } from 'ui/components/shared';
import App from './App';
import GlobalStyles from 'ui/theme/global';
import theme from 'ui/theme/config';
import 'ui/theme/fonts.css';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <BrowserRouter>
      <MainProvider>
        {/* keep MainProvider out of <React.StrictMode> tag */}
        <React.StrictMode>
          <App />
          <FlashModal />
        </React.StrictMode>
      </MainProvider>
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
